import { Grid, GridItem, Text } from '@chakra-ui/layout';
import { Button } from '@chakra-ui/react';
import { Spinner } from '@chakra-ui/spinner';
import { Link } from 'react-router-dom';

interface ITopNavProps {
	backLink: string | (() => void);
	backText: string;
	title: string;
	isLoading?: boolean;
	action?: React.ReactNode;
}

export default function TopNav(props: ITopNavProps) {
	return (
		<Grid
			width="100%"
			height="72px"
			templateColumns="repeat(4, 1fr)"
			templateRows="repeat(1, 1fr)"
			alignItems="center"
			padding="0 1.2rem"
		>
			<GridItem colStart={0} colEnd={2}>
				{typeof props.backLink === 'function' ? (
					<Button colorScheme="blue" variant="link" fontWeight="400" onClick={props.backLink}>
						{props.backText}
					</Button>
				) : (
					<Button colorScheme="blue" variant="link" as={Link} to={props.backLink} fontWeight="400">
						{props.backText}
					</Button>
				)}
			</GridItem>

			<GridItem colStart={2} colEnd={4}>
				<Text
					flex="1"
					fontWeight="700"
					overflow="hidden"
					textAlign="center"
					textOverflow="ellipsis"
					whiteSpace="nowrap"
					title={props.title}
				>
					{props.title}
				</Text>
			</GridItem>

			<GridItem justifySelf="end">
				{props.isLoading ? <Spinner color="green.400" marginRight=".3rem" /> : props.action ? props.action : null}
			</GridItem>
		</Grid>
	);
}
